import JWT from 'jwt/jwt';
import {isDefined} from 'utils';
import {
  AUTH_ENDPOINT,
  STATE_STORAGE_KEY,
  LOGIN_ENDPOINT,
  HEALTH_HUB_TOOLS_ENDPOINT,
  LOGOUT_ENDPOINT
} from 'api/constants';
import {DVZA_SUPPORT_CONSOLE_SEARCH_SCOPE, DVZA_SUPPORT_CONSOLE_REPORTS_SCOPE} from './constants';

export const getJwtReponsePromise = (response, jwsKeys) => {
  const jwt = response;
  try {
    return JWT.validate(window.Jose, jwt, jwsKeys).then((isValid) => {
      if (!isValid) {
        throw new Error('JWT failed signature verification');
      }
      response = JWT.parse(jwt).payload;

      return Promise.resolve(response);
    });
  } catch {
    console.error('Failed to read user data');
  }
};

export const requestAccessToken = async (openId) => {
  const {openIdConnectBaseUrl, clientId, scope, responseType, redirectUri} = openId;
  let url =
    `${openIdConnectBaseUrl}/${AUTH_ENDPOINT}` +
    '?client_id=' +
    clientId +
    '&scope=' +
    scope +
    '&state=' +
    (await generateAndPersistRandomValue(STATE_STORAGE_KEY)) +
    '&response_type=' +
    responseType +
    '&redirect_uri=' +
    redirectUri;

  window.location.replace(url);
};

const generateAndPersistRandomValue = async (storageKey) => {
  let randomValue = generateRandomValue();
  localStorage.setItem(storageKey, bytesToHex(randomValue));

  return await createHash(randomValue);
};

const generateRandomValue = () => {
  let cryptoObj = window.crypto || window.msCrypto;
  let value = new Uint8Array(32);
  cryptoObj.getRandomValues(value);
  return cryptoObj.getRandomValues(value);
};

const bytesToHex = (byteBuffer) => {
  return [...new Uint8Array(byteBuffer)].map((x) => x.toString(16).padStart(2, '0')).join('');
};

const createHash = async (value) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(value);
  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hash = bytesToHex(hashBuffer);
  return hash;
};

export const getUrlParameterByName = (name) => {
  let url = window.location.href;
  name = name.replace(/[[\]]/g, '\\$&');
  let regex = new RegExp('[?&#]' + name + '(=([^&#]*)|&|#|$)');
  let results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

export const getRightsFromScopeUrlParameter = (configScope) => {
  let scope = getUrlParameterByName('scope') || configScope;
  return {
    search: hasScope(scope, DVZA_SUPPORT_CONSOLE_SEARCH_SCOPE),
    reports: hasScope(scope, DVZA_SUPPORT_CONSOLE_REPORTS_SCOPE)
  };
};

export const validateAuthorizationState = (tokenType, today, expiration, accessToken, rights) => {
  const tokenTypeIsValid = computeIsTokenTypeValid(tokenType);
  const isTokenActive = computeIsTokenActive(today, expiration);
  const tokenStateIsValid = computeIsAccessTokenValid(accessToken);
  const scopeIsValid = rights.search || rights.reports;

  if (tokenTypeIsValid && isTokenActive && tokenStateIsValid && scopeIsValid) {
    finishAuthorization();
    if (!rights.search && rights.reports) {
      clearUrlFragment('#/reports');
    } else {
      clearUrlFragment('#/');
    }
    return true;
  } else {
    return false;
  }
};

const finishAuthorization = () => {
  localStorage.removeItem(STATE_STORAGE_KEY);
};

const computeIsTokenTypeValid = (tokenType) => {
  return tokenType === 'Bearer';
};

const computeIsTokenActive = (today, expiration) => {
  const now = Math.round(Date.now() / 1000);
  let expiresIn = today + parseInt(expiration);

  return expiresIn > now;
};

const computeIsAccessTokenValid = async (accessToken) => {
  if (isDefined(accessToken)) {
    const localState = localStorage.getItem(STATE_STORAGE_KEY);
    const hash = createHash(localState);
    return accessToken === hash;
  }
};

const hasScope = (scopes, wantedScope) => {
  return scopes?.includes(wantedScope) || false;
};

export const clearUrlFragment = (page) => {
  window.location.href = page;
};

export const reinitiateAuthorization = (flagshipBaseUrl) => {
  clearStorage();
  redirectToLoginPage(flagshipBaseUrl);
};
const clearStorage = () => {
  localStorage.clear();
};

const redirectToLoginPage = (flagshipBaseUrl) => {
  window.location.href = `${flagshipBaseUrl}/${LOGIN_ENDPOINT}`;
};

export const redirectToHealthHubTools = (flagshipBaseUrl) => {
  window.location.href = `${flagshipBaseUrl}/${HEALTH_HUB_TOOLS_ENDPOINT}`;
};
export const handleLogout = (flagshipBaseUrl) => {
  window.location.href = `${flagshipBaseUrl}/${LOGOUT_ENDPOINT}`;
};
export const handleReloadApp = () => {
  clearStorage();

  window.location.href = window.location.origin;
};
